/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "title": "PDFBolt",
  "tagline": "PDF Generation API",
  "url": "https://pdfbolt.com",
  "baseUrl": "/",
  "ssrTemplate": "<!DOCTYPE html>\n<html <%~ it.htmlAttributes %>>\n  <head>\n    <meta charset=\"UTF-8\">\n    <script>\n      (function () {\n        var docsColorModeKey = 'pdfbolt-docs-color-mode';\n        var docusaurusColorModeKey = 'theme';\n        var isDocsOrBlog = /^\\/(docs|blog)(\\/|$)/.test(window.location.pathname);\n        var root = document.documentElement;\n        var theme = 'light';\n\n        try {\n          if (isDocsOrBlog) {\n            theme = window.localStorage.getItem(docsColorModeKey) === 'dark' ? 'dark' : 'light';\n            window.localStorage.setItem(docusaurusColorModeKey, theme);\n            root.setAttribute('data-pdfbolt-docs-color-scope', 'true');\n          } else {\n            window.localStorage.setItem(docusaurusColorModeKey, 'light');\n            root.removeAttribute('data-pdfbolt-docs-color-scope');\n          }\n        } catch (error) {\n          root.removeAttribute('data-pdfbolt-docs-color-scope');\n        }\n\n        root.setAttribute('data-theme', theme);\n      })();\n    </script>\n    <meta name=\"generator\" content=\"Docusaurus v<%= it.version %>\">\n    <% it.metaAttributes.forEach((metaAttribute) => { %>\n      <%~ metaAttribute %>\n    <% }); %>\n    <%~ it.headTags %>\n    <% it.stylesheets.forEach((stylesheet) => { %>\n      <link rel=\"stylesheet\" href=\"<%= it.baseUrl %><%= stylesheet %>\" />\n    <% }); %>\n    <% it.scripts.forEach((script) => { %>\n      <script src=\"<%= it.baseUrl %><%= script %>\" defer></script>\n    <% }); %>\n  </head>\n  <body <%~ it.bodyAttributes %>>\n    <%~ it.preBodyTags %>\n    <div id=\"__docusaurus\"><%~ it.appHtml %></div>\n    <%~ it.postBodyTags %>\n  </body>\n</html>\n",
  "onBrokenLinks": "throw",
  "onBrokenMarkdownLinks": "throw",
  "onBrokenAnchors": "warn",
  "favicon": "img/favicon.ico",
  "organizationName": "pdfbolt",
  "projectName": "pdfbolt-landing-page",
  "customFields": {
    "recaptchaSiteKey": "6LdnmdQsAAAAAN2Ktijp5chSHVy_N3he0jE0znMY",
    "apiUrl": "https://api.pdfbolt.com",
    "frontendUrl": "https://app.pdfbolt.com",
    "freeToolsUrl": "https://tools.pdfbolt.com"
  },
  "trailingSlash": false,
  "clientModules": [
    "/opt/buildhome/repo/src/clientModules/sentry.js",
    "/opt/buildhome/repo/src/clientModules/patchDomForTranslate.js"
  ],
  "i18n": {
    "defaultLocale": "en",
    "locales": [
      "en"
    ],
    "path": "i18n",
    "localeConfigs": {}
  },
  "scripts": [
    {
      "src": "/js/prod/crispchat.js",
      "async": true
    },
    {
      "src": "https://szeer.pdfbolt.com/js/script.js",
      "defer": true,
      "data-domain": "pdfbolt.com"
    }
  ],
  "headTags": [
    {
      "tagName": "script",
      "attributes": {
        "type": "application/ld+json"
      },
      "innerHTML": "{\"@context\":\"https://schema.org\",\"@type\":\"Organization\",\"name\":\"PDFBolt\",\"url\":\"https://pdfbolt.com\",\"logo\":\"https://pdfbolt.com/img/logo.svg\",\"description\":\"PDFBolt provides a developer-first PDF generation API. Convert HTML, URLs, and templates to professional PDFs with AI-powered template generation, GDPR compliance, and EU-based processing.\",\"sameAs\":[\"https://www.linkedin.com/company/pdfbolt\",\"https://x.com/pdfbolt\",\"https://github.com/pdfbolt\"],\"founder\":[{\"@type\":\"Person\",\"name\":\"Michał\",\"jobTitle\":\"Co-founder\",\"url\":\"https://www.linkedin.com/in/micha%C5%82-szymanowski-461a9489/\"},{\"@type\":\"Person\",\"name\":\"Milena\",\"jobTitle\":\"Co-founder\"}]}"
    }
  ],
  "plugins": [
    "docusaurus-plugin-sass",
    "./plugins/body-script-plugin",
    "./plugins/sentry-webpack-plugin",
    [
      "@scalar/docusaurus",
      {
        "label": "OpenAPI Reference",
        "route": "/docs/api-reference",
        "showNavLink": false,
        "cdn": "https://cdn.jsdelivr.net/npm/@scalar/api-reference@1.55.3/dist/browser/standalone.js",
        "configuration": {
          "url": "/openapi.yaml",
          "servers": [
            {
              "url": "https://api.pdfbolt.com",
              "description": "PDFBolt API"
            }
          ],
          "title": "PDFBolt API Reference",
          "layout": "modern",
          "theme": "default",
          "documentDownloadType": "yaml",
          "hideDownloadButton": false,
          "hideModels": false,
          "hideClientButton": true,
          "hideTestRequestButton": false,
          "persistAuth": false,
          "telemetry": false,
          "showSidebar": true,
          "showDeveloperTools": "never",
          "showToolbar": "never",
          "operationTitleSource": "path",
          "defaultHttpClient": {
            "targetKey": "shell",
            "clientKey": "curl"
          },
          "orderSchemaPropertiesBy": "preserve",
          "orderRequiredPropertiesFirst": true,
          "agent": {
            "disabled": true
          },
          "mcp": {
            "disabled": true
          }
        }
      }
    ],
    [
      "docusaurus-plugin-llms",
      {
        "title": "PDFBolt - Scalable and Privacy‑First PDF Generation API",
        "description": "PDFBolt API - generate professional PDFs from HTML, URLs, and dynamic templates using REST endpoints. Supports Node.js, Python, Java, PHP, C#, Go, Rust with Direct/Sync/Async modes, AI-powered template generation, Handlebars templates, direct S3 uploads, automation platform integrations (n8n, Make, Zapier), interactive Playground, team collaboration, GDPR compliance, and enterprise-grade privacy.",
        "generateLLMsTxt": true,
        "generateLLMsFullTxt": true,
        "docsDir": "docs",
        "includeBlog": false,
        "excludeImports": true,
        "removeDuplicateHeadings": true,
        "generateMarkdownFiles": false,
        "includeOrder": [
          "docs/index.mdx",
          "docs/pdf-mcp-server/index.mdx",
          "docs/pdf-mcp-server/codex.mdx",
          "docs/pdf-mcp-server/claude-code.mdx",
          "docs/pdf-mcp-server/claude.mdx",
          "docs/pdf-mcp-server/cursor.mdx",
          "docs/pdf-mcp-server/vs-code.mdx",
          "docs/pdf-mcp-server/hermes-agent.mdx",
          "docs/pdf-mcp-server/openclaw.mdx",
          "docs/pdf-mcp-server/other-clients.mdx",
          "docs/quick-start-guide/index.mdx",
          "docs/sdks/index.mdx",
          "docs/sdks/nodejs.mdx",
          "docs/sdks/python.mdx",
          "docs/sdks/php.mdx",
          "docs/quick-start-guide/nodeJS.mdx",
          "docs/quick-start-guide/python.mdx",
          "docs/quick-start-guide/java.mdx",
          "docs/quick-start-guide/php.mdx",
          "docs/quick-start-guide/csharp.mdx",
          "docs/quick-start-guide/go.mdx",
          "docs/quick-start-guide/rust.mdx",
          "docs/quick-start-guide/postman.mdx",
          "docs/automation-platform-integrations/index.mdx",
          "docs/automation-platform-integrations/n8n-integration-guide/index.mdx",
          "docs/automation-platform-integrations/n8n-integration-guide/pdfbolt-community-node.mdx",
          "docs/automation-platform-integrations/n8n-integration-guide/http-request-node.mdx",
          "docs/automation-platform-integrations/make-integration-guide.mdx",
          "docs/automation-platform-integrations/zapier-integration-guide.mdx",
          "docs/automation-platform-integrations/airtable-integration-guide.mdx",
          "docs/automation-platform-integrations/bubble-integration-guide.mdx",
          "docs/automation-platform-integrations/integrately-integration-guide.mdx",
          "docs/api-endpoints/index.mdx",
          "docs/api-endpoints/direct.mdx",
          "docs/api-endpoints/sync.mdx",
          "docs/api-endpoints/async.mdx",
          "docs/api-endpoints/usage-monitoring.mdx",
          "docs/api-endpoints/template-api.mdx",
          "docs/parameters/index.mdx",
          "docs/error-handling/index.mdx",
          "docs/rate-limits/index.mdx",
          "docs/pdf-templates/index.mdx",
          "docs/ai-pdf-template-generation/index.mdx",
          "docs/async-workflow/index.mdx",
          "docs/s3-bucket-upload/index.mdx",
          "docs/dashboard/index.mdx",
          "docs/dashboard/playground.mdx",
          "docs/dashboard/templates.mdx",
          "docs/dashboard/logs.mdx",
          "docs/dashboard/api-keys.mdx",
          "docs/dashboard/subscription.mdx",
          "docs/dashboard/team.mdx",
          "docs/dashboard/settings.mdx",
          "docs/ip-addresses/index.mdx",
          "docs/privacy/index.mdx",
          "docs/faq/index.mdx"
        ],
        "pathTransformation": {
          "ignorePaths": [
            "/index"
          ]
        },
        "includeUnmatchedLast": false
      }
    ]
  ],
  "presets": [
    [
      "classic",
      {
        "docs": {
          "sidebarPath": "./sidebars.js"
        },
        "blog": {
          "path": "./blog",
          "routeBasePath": "/blog",
          "showReadingTime": true,
          "blogSidebarTitle": "All Blog Posts",
          "blogSidebarCount": "ALL",
          "postsPerPage": 10,
          "feedOptions": {
            "type": "all",
            "title": "PDFBolt Blog",
            "description": "Latest updates and articles from PDFBolt"
          }
        },
        "sitemap": {
          "ignorePatterns": [
            "/blog/tags",
            "/blog/tags/",
            "/blog/tags/**",
            "/blog/page/**",
            "/blog/archive",
            "/blog/archive/",
            "/blog/authors",
            "/blog/authors/"
          ]
        },
        "theme": {
          "customCss": "/opt/buildhome/repo/src/css/custom.scss"
        }
      }
    ]
  ],
  "themeConfig": {
    "metadata": [
      {
        "name": "keywords",
        "content": "pdf generation api, html to pdf api, ai template generation, ai-powered pdf, dynamic pdf templates, handlebars pdf templates, pdf api service, nodejs pdf api, python pdf api, wkhtmltopdf alternative, pdf automation api, invoice pdf generator, document generation api, template-based pdf generation, rest pdf api, print production pdf api, pdf-x api, cmyk pdf conversion, icc color profile pdf"
      },
      {
        "name": "description",
        "content": "PDFBolt – Scalable and Privacy-First PDF Generation API with dynamic templates. Generate high-quality PDFs from HTML, URLs, and Handlebars templates instantly. Chrome-powered precision, PDF/X compliance, CMYK conversion, ICC color profiles, 50 free monthly conversions, GDPR-compliant, supports all programming languages."
      },
      {
        "name": "author",
        "content": "PDFBolt Team"
      },
      {
        "property": "og:title",
        "content": "PDFBolt – PDF Generation API with Dynamic Templates: Fast, Privacy-First & Developer-Friendly"
      },
      {
        "property": "og:description",
        "content": "Generate professional PDFs from HTML, URLs, and dynamic templates with PDFBolt API. Features dynamic Handlebars templates, Chrome-powered precision, direct S3 uploads, and enterprise-grade privacy. Perfect for invoices, reports, and certificates."
      },
      {
        "property": "og:image",
        "content": "https://img.pdfbolt.com/pdf-generation-api-og-image.png"
      },
      {
        "property": "og:image:width",
        "content": "1200"
      },
      {
        "property": "og:image:height",
        "content": "630"
      },
      {
        "property": "og:type",
        "content": "website"
      },
      {
        "property": "og:site_name",
        "content": "PDFBolt"
      },
      {
        "name": "twitter:card",
        "content": "summary_large_image"
      },
      {
        "name": "twitter:title",
        "content": "PDFBolt – PDF Generation API with Dynamic Templates"
      },
      {
        "name": "twitter:description",
        "content": "Professional PDF generation API with Handlebars templates. Generate high-quality PDFs from HTML, URLs, and dynamic templates. Chrome-powered, GDPR-compliant, 50 free conversions monthly. Supports Node.js, Python, PHP, Java & more."
      },
      {
        "name": "twitter:image",
        "content": "https://img.pdfbolt.com/pdf-generation-api-og-image.png"
      },
      {
        "name": "twitter:image:alt",
        "content": "PDFBolt PDF Generation API with Dynamic Templates"
      },
      {
        "name": "application-name",
        "content": "PDFBolt"
      }
    ],
    "colorMode": {
      "defaultMode": "light",
      "disableSwitch": false,
      "respectPrefersColorScheme": false
    },
    "docs": {
      "sidebar": {
        "autoCollapseCategories": true,
        "hideable": false
      },
      "versionPersistence": "localStorage"
    },
    "navbar": {
      "logo": {
        "alt": "PDFBolt",
        "src": "img/logo.svg"
      },
      "style": "dark",
      "items": [
        {
          "label": "Pricing",
          "to": "/pricing",
          "position": "right"
        },
        {
          "label": "Documentation",
          "to": "/docs",
          "position": "right"
        },
        {
          "label": "Blog",
          "to": "/blog",
          "position": "right"
        },
        {
          "label": "Templates",
          "to": "/pdf-templates",
          "position": "right"
        },
        {
          "to": "https://app.pdfbolt.com/login",
          "label": "Login",
          "position": "right",
          "target": "_self"
        },
        {
          "label": "Register",
          "to": "https://app.pdfbolt.com/register",
          "position": "right",
          "className": "navbar__login-button",
          "target": "_self"
        }
      ],
      "hideOnScroll": false
    },
    "footer": {
      "style": "dark",
      "links": [
        {
          "title": "Get started",
          "items": [
            {
              "label": "Sign In",
              "to": "https://app.pdfbolt.com/login",
              "target": "_self"
            },
            {
              "label": "Sign Up",
              "to": "https://app.pdfbolt.com/register",
              "target": "_self"
            },
            {
              "label": "API Documentation",
              "to": "/docs"
            },
            {
              "label": "Template API",
              "to": "/docs/api-endpoints/template-api"
            },
            {
              "label": "Node.js SDK",
              "to": "/docs/sdks/nodejs"
            },
            {
              "label": "Python SDK",
              "to": "/docs/sdks/python"
            },
            {
              "label": "PHP SDK",
              "to": "/docs/sdks/php"
            },
            {
              "label": "OpenAPI Reference",
              "to": "/docs/api-reference"
            },
            {
              "label": "OpenAPI YAML",
              "href": "https://pdfbolt.com/openapi.yaml"
            },
            {
              "html": "  <div style=\"display: flex; justify-content: left; margin-top: 8px; margin-left: -7px;\">\n                                        <iframe src=\"https://status.pdfbolt.com/badge?theme=dark\" width=\"320\" height=\"30\" style=\"color-scheme: normal; border: none;\" title=\"PDFBolt Service Status\"></iframe>\n                                     </div>"
            }
          ]
        },
        {
          "title": "Free Tools",
          "items": [
            {
              "label": "Free HTML to PDF Converter",
              "to": "/tools/free-html-to-pdf-converter"
            },
            {
              "label": "Free URL to PDF Converter",
              "to": "/tools/free-url-to-pdf-converter"
            },
            {
              "label": "Free PDF Compressor",
              "to": "/tools/free-pdf-compressor"
            },
            {
              "label": "Free PDF/X Converter",
              "to": "/tools/free-pdfx-converter"
            },
            {
              "label": "Free Invoice Generator",
              "to": "/tools/free-invoice-generator"
            },
            {
              "label": "Free Receipt Generator",
              "to": "/tools/free-receipt-generator"
            },
            {
              "label": "Free Certificate Generator",
              "to": "/tools/free-certificate-generator"
            },
            {
              "label": "Free Quote Generator",
              "to": "/tools/free-quote-generator"
            },
            {
              "label": "Free Shipping Label Generator",
              "to": "/tools/free-shipping-label-generator"
            },
            {
              "label": "Free Resume Builder",
              "to": "/tools/free-resume-builder"
            },
            {
              "label": "Free Gift Card Generator",
              "to": "/tools/free-gift-card-generator"
            }
          ]
        },
        {
          "title": "Resources",
          "items": [
            {
              "label": "Free PDF Tools",
              "to": "/tools"
            },
            {
              "label": "AI PDF Generator",
              "to": "/ai-pdf-generator"
            },
            {
              "label": "PDF Templates Gallery",
              "to": "/pdf-templates"
            },
            {
              "label": "HTML to PDF API",
              "to": "/html-to-pdf-api"
            },
            {
              "label": "URL to PDF API",
              "to": "/url-to-pdf-api"
            },
            {
              "label": "HTML to PDF Comparisons",
              "to": "/compare"
            },
            {
              "label": "Gotenberg Alternative",
              "to": "/compare/gotenberg"
            },
            {
              "label": "Puppeteer Alternative for PDF",
              "to": "/compare/puppeteer"
            },
            {
              "label": "wkhtmltopdf Alternative",
              "to": "/compare/wkhtmltopdf"
            },
            {
              "label": "IronPDF Alternative",
              "to": "/compare/ironpdf"
            },
            {
              "label": "DocRaptor Alternative",
              "to": "/compare/docraptor"
            },
            {
              "label": "PDFShift Alternative",
              "to": "/compare/pdfshift"
            },
            {
              "label": "Browserless Alternative for PDF",
              "to": "/compare/browserless"
            },
            {
              "label": "Web to PDF Chrome Extension",
              "href": "https://chromewebstore.google.com/detail/aafaichoeonebgkkaccgknhabimheihl?utm_source=item-share-cb"
            },
            {
              "label": "Upload to S3 Bucket",
              "to": "/docs/s3-bucket-upload"
            },
            {
              "label": "Async Workflow",
              "to": "/docs/async-workflow"
            },
            {
              "label": "llms.txt",
              "href": "https://pdfbolt.com/llms.txt"
            },
            {
              "label": "llms-full.txt",
              "href": "https://pdfbolt.com/llms-full.txt"
            }
          ]
        },
        {
          "title": "More",
          "items": [
            {
              "label": "Blog",
              "href": "/blog"
            },
            {
              "label": "Customers",
              "to": "/customers"
            },
            {
              "label": "Changelog",
              "to": "/changelog"
            },
            {
              "label": "About Us",
              "to": "/about-us"
            },
            {
              "label": "Contact Us",
              "to": "/contact"
            },
            {
              "label": "Terms of Service",
              "href": "/terms"
            },
            {
              "label": "Privacy Policy",
              "href": "/privacy"
            },
            {
              "label": "Data Processing Agreement",
              "href": "/data-processing-agreement"
            },
            {
              "label": "Service Level Agreement",
              "href": "/service-level-agreement"
            },
            {
              "label": "For Non-Profits",
              "to": "/nonprofits"
            }
          ]
        },
        {
          "title": "Industries",
          "items": [
            {
              "label": "Legal",
              "to": "/industries/legal"
            },
            {
              "label": "Healthcare",
              "to": "/industries/healthcare"
            },
            {
              "label": "E-commerce",
              "to": "/industries/ecommerce"
            },
            {
              "label": "Human Resources",
              "to": "/industries/human-resources"
            },
            {
              "label": "Logistics",
              "to": "/industries/logistics"
            }
          ]
        }
      ],
      "copyright": "\n                <div style=\"display: flex; flex-direction: column; align-items: center; width: 100%;\">\n\n                    <!-- Second Row: Three Column Layout -->\n                    <div class=\"footer-row\"\n                         style=\"display: flex; justify-content: space-between; align-items: center; width: 100%; max-width: 1280px; flex-wrap: wrap;\">\n\n                        <!-- Left: PDF Association membership -->\n                        <a href=\"https://pdfa.org/member/pdfbolt/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"footer-pdfa-link\" style=\"display: flex; align-items: center; justify-content: flex-start; text-decoration: none; flex: 1 1 220px; min-width: 0;\">\n                            <img\n                                    class=\"footer-pdfa-logo\"\n                                    src=\"https://img.pdfbolt.com/PDF-Association-Member-Logo-invert-dark.png\"\n                                    alt=\"PDF Association Member logo\"\n                            />\n                        </a>\n\n                        <!-- Center: Stripe Climate and EU hosting -->\n                        <div class=\"footer-trust\" style=\"display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; flex: 2 1 400px; min-width: 0;\">\n                        <a href=\"https://climate.stripe.com/Qol24G\" target=\"_blank\" class=\"footer-stripe-link\" style=\"display: flex; align-items: center; justify-content: center; text-decoration: none;\">\n                            <div class=\"footer-stripe\" style=\"display: inline-flex; align-items: center; gap: 10px;\">\n                                <p>\n                                    1% of purchases contributed to <span style=\"color: #00cf1e; font-weight: 600\">Stripe Climate</span>\n                                </p>\n                                <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"ProductIcon ProductIcon--Climate \"\n                                     width=\"20\" height=\"20\" viewBox=\"0 0 40 40\" fill=\"none\"><title>Climate logo</title>\n                                    <path d=\"M33.24 21.09c-4.28 0-9.09-2.96-13.24-5.81-4.4-3.04-9.24-7.05-13.24-7.05C2.68 8.23 0 11.96 0 15.28v.28a20 20 0 1 0 40 0c-.13 2.68-2.03 5.53-6.76 5.53z\"\n                                          fill=\"url(#product-icon-climate-ProductHeroCaption-a)\"/>\n                                    <path d=\"M33.24 8.24c-4 0-8.84 4-13.24 7.04-4.15 2.85-8.96 5.8-13.24 5.8-4.73 0-6.63-2.84-6.76-5.52a20 20 0 1 0 40 0v-.28c0-3.32-2.67-7.05-6.76-7.04z\"\n                                          fill=\"url(#product-icon-climate-ProductHeroCaption-b)\"/>\n                                    <path d=\"M20 15.28c4.15 2.85 8.96 5.8 13.24 5.8 4.73 0 6.63-2.84 6.76-5.52a20 20 0 1 1-40 0c.13 2.68 2.03 5.53 6.76 5.53 4.28 0 9.09-2.96 13.24-5.81z\"\n                                          fill=\"url(#product-icon-climate-ProductHeroCaption-c)\"/>\n                                    <defs>\n                                        <linearGradient id=\"product-icon-climate-ProductHeroCaption-a\" x1=\"20\"\n                                                        y1=\"20.63\" x2=\"20\" y2=\"9.57\" gradientUnits=\"userSpaceOnUse\">\n                                            <stop stop-color=\"#FFD748\"/>\n                                            <stop offset=\".21\" stop-color=\"#FFD644\"/>\n                                            <stop offset=\".33\" stop-color=\"#FFD438\"/>\n                                            <stop offset=\".45\" stop-color=\"#FFD024\"/>\n                                            <stop offset=\".57\" stop-color=\"#FFCB09\"/>\n                                            <stop offset=\"1\" stop-color=\"#FFC900\"/>\n                                        </linearGradient>\n                                        <linearGradient id=\"product-icon-climate-ProductHeroCaption-b\" x1=\"20\" y1=\"9.56\"\n                                                        x2=\"20\" y2=\"21.9\" gradientUnits=\"userSpaceOnUse\">\n                                            <stop stop-color=\"#009C00\"/>\n                                            <stop offset=\"1\" stop-color=\"#00BA18\"/>\n                                        </linearGradient>\n                                        <linearGradient id=\"product-icon-climate-ProductHeroCaption-c\" x1=\"20\"\n                                                        y1=\"35.28\" x2=\"20\" y2=\"15.28\" gradientUnits=\"userSpaceOnUse\">\n                                            <stop offset=\".13\" stop-color=\"#00CB1B\"/>\n                                            <stop offset=\"1\" stop-color=\"#00D924\"/>\n                                        </linearGradient>\n                                    </defs>\n                                </svg>\n                            </div>\n                        </a>\n                        <div class=\"footer-eu\" style=\"display: inline-flex; justify-content: center;\">\n          <span style=\"display: flex; align-items: center; gap: 8px;\">\n           <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" height=\"22px\" width=\"22px\"\n                id=\"Layer_1\" viewBox=\"0 0 512 512\" xml:space=\"preserve\">\n<path style=\"fill:#41479B;\"\n      d=\"M473.655,88.275H38.345C17.167,88.275,0,105.442,0,126.62V385.38  c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345V126.62  C512,105.442,494.833,88.275,473.655,88.275z\"/>\n<g>\n<path style=\"fill:#FFE15A;\"\n      d=\"M259.59,126.684l3.54,10.613l11.187,0.087c1.449,0.011,2.049,1.859,0.884,2.72l-9,6.646   l3.374,10.666c0.437,1.38-1.135,2.524-2.314,1.681l-9.101-6.506l-9.101,6.506c-1.178,0.842-2.751-0.3-2.314-1.681l3.374-10.666   l-9-6.646c-1.165-0.861-0.565-2.709,0.884-2.72l11.187-0.087l3.54-10.613C257.187,125.31,259.132,125.31,259.59,126.684z\"/>\n<path style=\"fill:#FFE15A;\"\n      d=\"M259.59,354.547l3.54,10.613l11.187,0.087c1.449,0.011,2.049,1.859,0.884,2.72l-9,6.646   l3.374,10.666c0.437,1.38-1.135,2.524-2.314,1.681l-9.101-6.506l-9.101,6.506c-1.178,0.842-2.751-0.3-2.314-1.681l3.374-10.666   l-9-6.646c-1.165-0.861-0.565-2.709,0.884-2.72l11.187-0.087l3.54-10.613C257.187,353.172,259.132,353.172,259.59,354.547z\"/>\n<path style=\"fill:#FFE15A;\"\n      d=\"M373.521,240.615l3.54,10.613l11.187,0.087c1.449,0.011,2.049,1.859,0.884,2.72l-9,6.646   l3.374,10.666c0.437,1.38-1.135,2.524-2.314,1.681l-9.101-6.506l-9.101,6.506c-1.178,0.842-2.751-0.3-2.314-1.681l3.374-10.666   l-9-6.646c-1.165-0.861-0.565-2.709,0.884-2.72l11.187-0.087l3.54-10.613C371.118,239.242,373.063,239.242,373.521,240.615z\"/>\n<path style=\"fill:#FFE15A;\"\n      d=\"M145.658,240.615l3.54,10.613l11.187,0.087c1.449,0.011,2.049,1.859,0.884,2.72l-9,6.646   l3.374,10.666c0.437,1.38-1.135,2.524-2.314,1.681l-9.101-6.506l-9.101,6.506c-1.178,0.842-2.751-0.3-2.314-1.681l3.374-10.666   l-9-6.646c-1.165-0.861-0.565-2.709,0.884-2.72l11.187-0.087l3.54-10.613C143.256,239.242,145.201,239.242,145.658,240.615z\"/>\n<path style=\"fill:#FFE15A;\"\n      d=\"M162.762,181.119l3.54,10.613l11.187,0.087c1.449,0.011,2.049,1.859,0.884,2.72l-9,6.646   l3.374,10.666c0.437,1.38-1.135,2.524-2.314,1.681l-9.101-6.506l-9.101,6.506c-1.178,0.842-2.751-0.3-2.314-1.681l3.374-10.666   l-9-6.646c-1.165-0.861-0.565-2.709,0.884-2.72l11.187-0.087l3.54-10.613C160.36,179.745,162.303,179.745,162.762,181.119z\"/>\n<path style=\"fill:#FFE15A;\"\n      d=\"M360.096,295.05l3.54,10.613l11.187,0.087c1.449,0.011,2.049,1.859,0.884,2.72l-9,6.646   l3.374,10.666c0.437,1.382-1.135,2.524-2.314,1.681l-9.101-6.506l-9.101,6.506c-1.178,0.842-2.751-0.3-2.314-1.681l3.374-10.666   l-9-6.646c-1.165-0.861-0.565-2.709,0.884-2.72l11.187-0.087l3.54-10.613C357.694,293.677,359.638,293.677,360.096,295.05z\"/>\n<path style=\"fill:#FFE15A;\"\n      d=\"M318.395,139.417l3.54,10.613l11.187,0.087c1.449,0.011,2.049,1.859,0.884,2.72l-9,6.646   l3.374,10.666c0.437,1.38-1.135,2.524-2.314,1.681l-9.101-6.506l-9.102,6.506c-1.178,0.842-2.751-0.3-2.314-1.681l3.374-10.666   l-9-6.646c-1.165-0.861-0.565-2.709,0.884-2.72l11.187-0.087l3.54-10.613C315.992,138.044,317.935,138.044,318.395,139.417z\"/>\n<path style=\"fill:#FFE15A;\"\n      d=\"M204.463,336.753l3.54,10.613l11.187,0.087c1.449,0.011,2.049,1.859,0.884,2.72l-9,6.646   l3.374,10.666c0.437,1.38-1.135,2.524-2.314,1.681l-9.101-6.506l-9.101,6.506c-1.178,0.842-2.751-0.3-2.314-1.681l3.374-10.666   l-9-6.646c-1.165-0.861-0.565-2.709,0.884-2.72l11.187-0.086l3.54-10.613C202.061,335.378,204.006,335.378,204.463,336.753z\"/>\n<path style=\"fill:#FFE15A;\"\n      d=\"M357.236,181.119l-3.54,10.613l-11.187,0.087c-1.449,0.011-2.049,1.859-0.884,2.72l9,6.646   l-3.374,10.666c-0.437,1.38,1.135,2.524,2.314,1.681l9.101-6.506l9.101,6.506c1.178,0.842,2.751-0.3,2.314-1.681l-3.374-10.666   l9-6.646c1.165-0.861,0.565-2.709-0.884-2.72l-11.187-0.087l-3.54-10.613C359.638,179.745,357.694,179.745,357.236,181.119z\"/>\n<path style=\"fill:#FFE15A;\"\n      d=\"M159.902,295.05l-3.54,10.613l-11.187,0.087c-1.449,0.011-2.049,1.859-0.884,2.72l9,6.646   l-3.374,10.666c-0.437,1.382,1.135,2.524,2.314,1.681l9.101-6.506l9.101,6.506c1.178,0.842,2.751-0.3,2.314-1.681l-3.374-10.666   l9-6.646c1.165-0.861,0.565-2.709-0.884-2.72l-11.187-0.087l-3.54-10.613C162.303,293.677,160.36,293.677,159.902,295.05z\"/>\n<path style=\"fill:#FFE15A;\"\n      d=\"M201.603,139.417l-3.54,10.613l-11.187,0.087c-1.449,0.011-2.049,1.859-0.884,2.72l9,6.646   l-3.374,10.666c-0.437,1.38,1.135,2.524,2.314,1.681l9.101-6.506l9.101,6.506c1.178,0.842,2.751-0.3,2.314-1.681l-3.374-10.666   l9-6.646c1.165-0.861,0.565-2.709-0.884-2.72l-11.187-0.087l-3.54-10.613C204.004,138.044,202.061,138.044,201.603,139.417z\"/>\n<path style=\"fill:#FFE15A;\"\n      d=\"M315.534,336.753l-3.54,10.613l-11.187,0.087c-1.449,0.011-2.049,1.859-0.884,2.72l9,6.646   l-3.374,10.666c-0.437,1.38,1.135,2.524,2.314,1.681l9.101-6.506l9.101,6.506c1.178,0.842,2.751-0.3,2.314-1.681l-3.374-10.666   l9-6.646c1.165-0.861,0.565-2.709-0.884-2.72l-11.187-0.086l-3.54-10.613C317.935,335.378,315.992,335.378,315.534,336.753z\"/>\n</g>\n</svg>\n              <p>EU-hosted with GDPR-compliant processing</p>\n          </span>\n                        </div>\n                        </div>\n\n                        <!-- Right: Social Media Icons -->\n                        <div class=\"footer-social\"\n                             style=\"display: inline-flex; align-items: center; justify-content: flex-end; gap: 8px; flex: 1 1 220px; min-width: 0;\">\n                            <a href=\"https://x.com/pdfbolt\" target=\"_blank\" style=\"display: inline-block;\">\n                                <img\n                                        src=\"/img/x.svg\"\n                                        alt=\"X\"\n                                        style=\"height: 18px; width: 18px; vertical-align: middle;\"\n                                />\n                            </a>\n                            <a href=\"https://www.linkedin.com/company/pdfbolt\" target=\"_blank\"\n                               style=\"display: inline-block;\">\n                                <img\n                                        src=\"/img/linkedin.svg\"\n                                        alt=\"LinkedIn\"\n                                        style=\"height: 19px; width: 19px; vertical-align: middle;\"\n                                />\n                            </a>\n                            <a href=\"https://www.facebook.com/pdfbolt\" target=\"_blank\" style=\"display: inline-block;\">\n                                <img\n                                        src=\"/img/facebook.svg\"\n                                        alt=\"Facebook\"\n                                        style=\"height: 18px; width: 18px; vertical-align: middle;\"\n                                />\n                            </a>\n                            <a href=\"https://www.youtube.com/@PDFBolt\" target=\"_blank\" style=\"display: inline-block;\">\n                                <img\n                                        src=\"/img/youtube.svg\"\n                                        alt=\"YouTube\"\n                                        style=\"height: 18px; width: 18px; vertical-align: middle;\"\n                                />\n                            </a>\n                            <a href=\"/contact\" style=\"display: inline-block;\">\n                                <img\n                                        src=\"/img/email.svg\"\n                                        alt=\"Email\"\n                                        style=\"height: 18px; width: 18px; vertical-align: middle;\"\n                                />\n                            </a>\n                            <a href=\"https://github.com/pdfbolt\" style=\"display: inline-block;\">\n                                <img\n                                        src=\"/img/github.svg\"\n                                        alt=\"GitHub\"\n                                        style=\"height: 19px; width: 19px; vertical-align: middle;\"\n                                />\n                            </a>\n                        </div>\n\n                    </div>\n\n                    <!-- Mobile responsive adjustments -->\n                    <style>\n                        .footer-row {\n                            margin-top: 25px;\n                        }\n                        .footer-pdfa-logo {\n                            height: 60px;\n                            width: auto;\n                            display: block;\n                        }\n                        .footer-stripe p {\n                            font-size: 15px;\n                            color: #fff;\n                            font-weight: 400;\n                            font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\";\n                            margin: 0;\n                        }\n                        .footer-eu span p {\n                            font-size: 15px;\n                            color: #fff;\n                            font-weight: 400;\n                            font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\";\n                            margin: 0;\n                        }\n\n                        @media (max-width: 1000px) {\n                            .footer-row {\n                                flex-direction: column;\n                                gap: 15px;\n                                text-align: center;\n                            }\n                            \n                            .footer-row > div {\n                                justify-content: center;\n                                flex: 0 0 auto !important;\n                            }\n\n                            .footer-row > a {\n                                flex: 0 0 auto !important;\n                            }\n\n                            .footer-row .footer-pdfa-link {\n                                order: 1;\n                                justify-content: center !important;\n                            }\n\n                            .footer-row .footer-trust {\n                                order: 2;\n                                flex: 0 0 auto !important;\n                                flex-basis: auto !important;\n                            }\n\n                            .footer-pdfa-logo {\n                                height: 52px;\n                            }\n\n                            .footer-row .footer-stripe p {\n                                font-size: 14px;\n                            }\n\n                            .footer-eu span p {\n                                font-size: 14px;\n                            }\n\n                            .footer-row .footer-social {\n                                order: 3;\n                                flex: none !important;\n                                justify-content: center !important;\n                            }\n                        }\n\n                        @media (max-width: 500px) {\n                            .footer-row .footer-stripe p {\n                                font-size: 13px;\n                            }\n\n                            .footer-eu span p {\n                                font-size: 13px;\n                            }\n                            .footer-row {\n                                margin-top: 0;\n                                gap: 15px;\n                            }\n                            .footer-pdfa-logo {\n                                height: 48px;\n                            }\n                        }\n                    </style>\n                </div>\n            "
    },
    "prism": {
      "theme": {
        "plain": {
          "color": "#393A34",
          "backgroundColor": "#f6f8fa"
        },
        "styles": [
          {
            "types": [
              "comment",
              "prolog",
              "doctype",
              "cdata"
            ],
            "style": {
              "color": "#999988",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "opacity": 0.7
            }
          },
          {
            "types": [
              "string",
              "attr-value"
            ],
            "style": {
              "color": "#e3116c"
            }
          },
          {
            "types": [
              "punctuation",
              "operator"
            ],
            "style": {
              "color": "#393A34"
            }
          },
          {
            "types": [
              "entity",
              "url",
              "symbol",
              "number",
              "boolean",
              "variable",
              "constant",
              "property",
              "regex",
              "inserted"
            ],
            "style": {
              "color": "#36acaa"
            }
          },
          {
            "types": [
              "atrule",
              "keyword",
              "attr-name",
              "selector"
            ],
            "style": {
              "color": "#00a4db"
            }
          },
          {
            "types": [
              "function",
              "deleted",
              "tag"
            ],
            "style": {
              "color": "#d73a49"
            }
          },
          {
            "types": [
              "function-variable"
            ],
            "style": {
              "color": "#6f42c1"
            }
          },
          {
            "types": [
              "tag",
              "selector",
              "keyword"
            ],
            "style": {
              "color": "#00009f"
            }
          }
        ]
      },
      "darkTheme": {
        "plain": {
          "color": "#F8F8F2",
          "backgroundColor": "#282A36"
        },
        "styles": [
          {
            "types": [
              "prolog",
              "constant",
              "builtin"
            ],
            "style": {
              "color": "rgb(189, 147, 249)"
            }
          },
          {
            "types": [
              "inserted",
              "function"
            ],
            "style": {
              "color": "rgb(80, 250, 123)"
            }
          },
          {
            "types": [
              "deleted"
            ],
            "style": {
              "color": "rgb(255, 85, 85)"
            }
          },
          {
            "types": [
              "changed"
            ],
            "style": {
              "color": "rgb(255, 184, 108)"
            }
          },
          {
            "types": [
              "punctuation",
              "symbol"
            ],
            "style": {
              "color": "rgb(248, 248, 242)"
            }
          },
          {
            "types": [
              "string",
              "char",
              "tag",
              "selector"
            ],
            "style": {
              "color": "rgb(255, 121, 198)"
            }
          },
          {
            "types": [
              "keyword",
              "variable"
            ],
            "style": {
              "color": "rgb(189, 147, 249)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(98, 114, 164)"
            }
          },
          {
            "types": [
              "attr-name"
            ],
            "style": {
              "color": "rgb(241, 250, 140)"
            }
          }
        ]
      },
      "additionalLanguages": [
        "bash",
        "java",
        "php",
        "ruby",
        "json",
        "csharp",
        "rust",
        "go",
        "python",
        "http"
      ],
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "stylesheets": [
      "/css/custom.scss"
    ],
    "algolia": {
      "appId": "ZKLIHWSMQ8",
      "apiKey": "ab9b1923a06a0cefedd7cced9ce6589c",
      "indexName": "pdfbolt",
      "contextualSearch": true,
      "searchParameters": {},
      "searchPagePath": "search"
    },
    "blog": {
      "sidebar": {
        "groupByYear": true
      }
    },
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    }
  },
  "baseUrlIssueBanner": true,
  "future": {
    "experimental_faster": {
      "swcJsLoader": false,
      "swcJsMinimizer": false,
      "swcHtmlMinimizer": false,
      "lightningCssMinimizer": false,
      "mdxCrossCompilerCache": false,
      "rspackBundler": false
    },
    "experimental_storage": {
      "type": "localStorage",
      "namespace": false
    },
    "experimental_router": "browser"
  },
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "themes": [],
  "stylesheets": [],
  "titleDelimiter": "|",
  "noIndex": false,
  "markdown": {
    "format": "mdx",
    "mermaid": false,
    "mdx1Compat": {
      "comments": true,
      "admonitions": true,
      "headingIds": true
    },
    "anchors": {
      "maintainCase": false
    }
  }
};
